import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { TrackingComponent } from './tracking.component';
import { TrackingStartComponent } from './tracking-start/tracking-start.component';
import { TrackingSearchComponent } from './tracking-search/tracking-search.component';
import { TrackingSearchResolve } from './tracking-search/tracking-search.resolve';

const moduleRoutes: Routes = [
  {
    path: '',
    component: TrackingComponent,

    children: [
      // {
      //   path: '',
      //   component: TrackingStartComponent,
      // },
      // {
      //   path: 'search',
      //   component: TrackingSearchComponent,
      // },
      {
        path: '',
        // resolve: {
        //   data: TrackingSearchResolve,
        // },
        // runGuardsAndResolvers: 'always',
        component: TrackingSearchComponent,
      },
    ],
  },

  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(moduleRoutes)],
  exports: [RouterModule],
  providers: [
    // AuthGuard
  ],
})
export class TrackingRoutingModule {}
